import { DocumentSearchResult } from '@/modules/pdf/DocumentSearch/DocumentSearch.types';

import {
  AskDocumentQuestion_FileParagraphFragment,
  AskDocumentQuestion_MessageFragment,
} from '../../graphql/AskDocumentQuestion.generated';

export function convertFileParagraphsToAnnotations(
  message: AskDocumentQuestion_MessageFragment
): DocumentSearchResult[] {
  if (!message.fileParagraphs) {
    return [];
  }

  return message.fileParagraphs.flatMap(
    (paragraph: AskDocumentQuestion_FileParagraphFragment) => {
      const documentID = paragraph.file?.pdfDocument?.id;
      if (!documentID || !paragraph.boundingRegions) {
        return [];
      }

      return paragraph.boundingRegions.map(
        (region: {
          PageNumber: number;
          Polygon: Array<{ x: number; y: number }>;
        }) => ({
          documentID,
          PageNumber: region.PageNumber,
          Polygon: region.Polygon,
        })
      );
    }
  );
}
